import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { switchMap } from 'rxjs';
import { environment } from '@env/environment';

const apiUrl = environment.AWS.apiUrl.replace(/\/$/, '');

export const apiIdTokenInterceptor: HttpInterceptorFn = (request, next) => {
    if (request.url !== apiUrl && !request.url.startsWith(`${apiUrl}/`)) {
        return next(request);
    }

    return inject(OidcSecurityService)
        .getIdToken()
        .pipe(
            switchMap(idToken =>
                next(
                    idToken
                        ? request.clone({
                              setHeaders: { Authorization: `Bearer ${idToken}` }
                          })
                        : request
                )
            )
        );
};
